var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#282B2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1261_5712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5685 20.5761C28.5685 22.4721 30.1055 24.0091 32.0015 24.0091C32.4808 24.0091 32.9372 23.9109 33.3516 23.7335C34.5764 23.2091 35.4346 21.9928 35.4346 20.5761C35.4346 18.6801 33.8975 17.1431 32.0015 17.1431C30.1055 17.1431 28.5685 18.6801 28.5685 20.5761Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2238 43.5915C40.2238 45.3949 41.6859 46.8571 43.4894 46.8571C43.9454 46.8571 44.3794 46.7636 44.7737 46.5949C45.9387 46.096 46.755 44.9392 46.755 43.5915C46.755 41.7879 45.293 40.3257 43.4894 40.3257C41.6859 40.3257 40.2238 41.7879 40.2238 43.5915Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7335 43.5915C28.7335 45.3949 30.1956 46.8571 31.9992 46.8571C32.4551 46.8571 32.8892 46.7636 33.2834 46.5949C34.4485 46.096 35.2648 44.9392 35.2648 43.5915C35.2648 41.7879 33.8027 40.3257 31.9992 40.3257C30.1956 40.3257 28.7335 41.7879 28.7335 43.5915Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2433 43.5915C17.2433 45.3949 18.7054 46.8571 20.5089 46.8571C20.9649 46.8571 21.399 46.7636 21.7932 46.5949C22.9583 46.096 23.7746 44.9392 23.7746 43.5915C23.7746 41.7879 22.3125 40.3257 20.5089 40.3257C18.7054 40.3257 17.2433 41.7879 17.2433 43.5915Z",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6157 30.8626C38.3284 27.4622 35.4774 24.792 32.0027 24.792C28.528 24.792 25.6769 27.4622 25.3896 30.8626",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5109 40.326V35.4229H43.4912V40.326",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0011 36.3623V40.326",
    stroke: "#00EC7B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1261_5712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile_3.c7c3a72f6e9492472d493a252ef8c719.svg";
export { ForwardRef as ReactComponent };